import Vue from 'vue';
import {
    mixin as clickaway
} from 'vue-clickaway';
import '../../section-specific/forms/forms';

Vue.component('drop-down', {
    mixins: [clickaway],
    props: ['language'],
    data () {
        return {
            isDropDownOpen: false
        }
    },
    methods: {
        away() {
            this.isDropDownOpen = false;
        },
        toggleDropDown(e) {
            this.isDropDownOpen = !this.isDropDownOpen;
        },
        selectSection (param) {
            this.$emit('clicked', param);
            this.away();
        }
    }
})

new Vue({
    el: '#app',
    data: function () {
        return {
            name: "Forms"
        }
    }
});